import Badge from "../../../components/ui/Badge";
import EmptyState from "../components/EmptyState";
import Timeline from "../components/Timeline";
import { formatYearRange, isLinkUrl, sortNewestFirst } from "../profileUtils";
import ui from "../../../components/ui/ui.module.css";

const EducationSection = ({ education }) => {
  if (!education.length) return <EmptyState />;

  const items = sortNewestFirst(education, (e) => e.yearTo ?? e.yearFrom).map(
    (e) => ({
      key: e.id,
      period: formatYearRange(e.yearFrom, e.yearTo),
      title: (
        <>
          {e.schoolName} {e.level && <Badge tone="purple">{e.level}</Badge>}
        </>
      ),
      body: (
        <>
          {e.course && <div>{e.course}</div>}
          {e.schoolAddress && <div className={ui.muted}>{e.schoolAddress}</div>}
          {isLinkUrl(e.file_url) && (
            <a
              href={e.file_url}
              target="_blank"
              rel="noopener noreferrer"
              className={ui.linkButton}
            >
              View file <i className="bi bi-box-arrow-up-right"></i>
            </a>
          )}
        </>
      ),
    }),
  );

  return <Timeline items={items} />;
};

export default EducationSection;
